// Shared presale config and helpers

// Key dates (UTC) — HARDCODED LAUNCH: July 1, 2026 04:00 UTC (= midnight Haiti UTC-4).
// Locked: do NOT override from environment. Same instant globally.
export const PRESALE_START = new Date('2026-07-01T04:00:00Z');
export const FOMO_START = new Date('2026-06-25T00:00:00Z');    // FOMO countdown
export const PHASE_DURATION_DAYS = 30;

export const BONUS_TIERS = [
  { min: 0, max: 50, bonus: 0 },
  { min: 50, max: 200, bonus: 5 },
  { min: 200, max: 500, bonus: 10 },
  { min: 500, max: 1000, bonus: 15 },
  { min: 1000, max: 2000, bonus: 20 },
  { min: 2000, max: 4000, bonus: 25 },
  { min: 4000, max: Infinity, bonus: 30 },
];

export const PRESALE_PHASES = [
  { phase: 1, price: 0.0010, cap: 100_000_000 },
  { phase: 2, price: 0.0015, cap: 100_000_000 },
  { phase: 3, price: 0.0020, cap: 100_000_000 },
  { phase: 4, price: 0.0025, cap: 100_000_000 },
];

export const PAY_CURRENCIES = [
  { code: 'usdcsol', label: 'USDC', chain: 'Solana', color: '#2775ca', icon: 'https://customer-assets.emergentagent.com/job_palette-preview-12/artifacts/gl1ibi7k_USDC_Logo.png' },
  { code: 'usdcmatic', label: 'USDC', chain: 'Polygon', color: '#8247e5', icon: 'https://customer-assets.emergentagent.com/job_palette-preview-12/artifacts/93n1blyn_Picsart_26-06-19_08-23-51-059.png' },
  { code: 'usdttrc20', label: 'USDT', chain: 'TRC20', color: '#26a17b', icon: 'https://customer-assets.emergentagent.com/job_palette-preview-12/artifacts/iy8lur0k_USDT-TRC20.png' },
  { code: 'usdtbsc', label: 'USDT', chain: 'BEP20', color: '#f3ba2f', icon: 'https://customer-assets.emergentagent.com/job_palette-preview-12/artifacts/8rgw7zab_USDT-BEP20-1.png' },
];

export const getBonusPercent = (amount) => {
  const tier = BONUS_TIERS.find(t => amount >= t.min && amount < t.max);
  return tier ? tier.bonus : 0;
};

export const getNextTier = (amount) => {
  const next = BONUS_TIERS.find(t => amount < t.min);
  return next || null;
};

export const getPresalePhaseStatus = (now = new Date()) => {
  if (now < FOMO_START) {
    return { state: 'pre-fomo', target: PRESALE_START, currentPhase: 1, label: 'COMING SOON' };
  }
  if (now < PRESALE_START) {
    return { state: 'fomo', target: PRESALE_START, currentPhase: 1, label: 'OPENS SOON' };
  }
  // Live: compute current phase
  const daysSinceStart = (now - PRESALE_START) / (1000 * 60 * 60 * 24);
  const phaseIdx = Math.min(3, Math.floor(daysSinceStart / PHASE_DURATION_DAYS));
  const phaseEnd = new Date(PRESALE_START.getTime() + (phaseIdx + 1) * PHASE_DURATION_DAYS * 24 * 60 * 60 * 1000);
  return { state: 'live', target: phaseEnd, currentPhase: phaseIdx + 1, label: 'PHASE LIVE' };
};

export const formatCountdown = (target, now = new Date()) => {
  const diff = Math.max(0, target.getTime() - now.getTime());
  const days = Math.floor(diff / (24 * 60 * 60 * 1000));
  const hours = Math.floor((diff % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
  const mins = Math.floor((diff % (60 * 60 * 1000)) / (60 * 1000));
  const secs = Math.floor((diff % (60 * 1000)) / 1000);
  return { days, hours, mins, secs, total: diff };
};
